// apps/web/src/features/russia-carriers/queries.ts
//
// Query-key constant for the Russia carriers admin catalog (#1166).
// Mirrors `ROAD_OPTIONS_CATALOG_QK`. The directory has no request-form
// picker today (#1167 will introduce one), so this catalog key is the
// only cache to invalidate after mutations.
//
// User-cache reset: this key is wiped in
// `apps/web/src/auth/userCacheReset.ts` per the `@aiInvariant` block
// for permission-gated reference catalogs (`contacts` is PII and must
// drop from cache on logout / role rotation).

export const RUSSIA_CARRIERS_CATALOG_QK = ['russia-carriers-catalog'] as const;
